import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a01a1882"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "installment-list" }
const _hoisted_2 = { class: "listing-titles" }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SuperPacmanInstallmentItem = _resolveComponent("SuperPacmanInstallmentItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('InstallmentsList-Title')), 1),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.installmentsAlwaysAvailable, (installment, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          _createVNode(_component_SuperPacmanInstallmentItem, {
            installment: installment,
            onSelectInstallmentItem: _ctx.handleSelectInstallment,
            onOtherAmount: _ctx.handleOtherAmount
          }, null, 8, ["installment", "onSelectInstallmentItem", "onOtherAmount"])
        ]))
      }), 128))
    ]),
    (!_ctx.hideMoreOptions)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "installment-list-toggle-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleConditionalInstallments && _ctx.toggleConditionalInstallments(...args)))
        }, _toDisplayString(_ctx.$t('superpacman-more-options')), 1))
      : _createCommentVNode("", true),
    (_ctx.showConditionalInstallments && !_ctx.hideMoreOptions)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.installmentsConditional, (installment, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createVNode(_component_SuperPacmanInstallmentItem, {
                installment: installment,
                onSelectInstallmentItem: _ctx.handleSelectInstallment,
                onOtherAmount: _ctx.handleOtherAmount
              }, null, 8, ["installment", "onSelectInstallmentItem", "onOtherAmount"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}